(function(angular) {
    'use strict';

    var scopeFocusEvent = 'focusOn';

    angular.module('aprima-core-ui').directive('focusOn', [
        focusOn,
    ]);

    angular.module('aprima-core-ui').factory('focus', [
        '$rootScope',
        '$timeout',
        focusFactory,
    ]);

    function focusOn(
    ) {
        var directive = {
            restrict: 'A',
            link: function(scope, elem, attr) {
                scope.$on(scopeFocusEvent, function(e, name) {
                    if (name === attr.focusOn) {
                        elem[0].focus();
                    }
                });
            },
        };

        return directive;
    }

    function focusFactory(
        $rootScope,
        $timeout
    ) {
        return focus;

        function focus(name) {
            $timeout(function() {
                $rootScope.$broadcast(scopeFocusEvent, name);
            });
        }
    }
})(window.angular);
